const selectors = {
  highlightSectionTitle: "highlight-section-title",
  highlightSectionItemTitle: "highlight-section-item-title",
  highlighSectionItemImage: "highlight-section-item-image",
  highlightSectionItemContent: "highlight-section-item-content",
};

export default selectors;
